import Formsy from 'formsy-react';
import React from 'react';
import { Row, Button, Colors } from 'react-foundation';
import { Reveal } from 'react-foundation-components/lib/global/reveal';
import { connect } from 'react-redux';
import { CloseModal } from '../layout/close-modal';

import { Input } from 'formsy-react-components';
import {
  changePassword,
  showChangePasswordModal
} from '../../state/auth/actions';

const ChangePassword = React.createClass({
  getInitialState() {
    return {
      canSubmit: false,
      changedPass: false
    };
  },

  enableButton() {
    this.setState({
      canSubmit: true
    });
  },

  disableButton() {
    this.setState({
      canSubmit: false
    });
  },

  handleShow() {
    this.props.dispatch(showChangePasswordModal(true));
  },

  handleHide() {
    this.props.dispatch(showChangePasswordModal(false));
  },

  handlePassChange() {
    this.setState({ changedPass: true });
  },

  submit(formData) {
    this.disableButton();
    this.setState({ changedPass: false });
    this.props.onSubmit(formData);
  },

  render() {
    const userMsg = this.props.passwordState.get('msg');
    return (
      <Reveal onHide={this.handleHide} size="tiny" show={this.props.show}>
        <div className="change-password-modal">
          <CloseModal onHide={this.handleHide} size={16} />
          <div className="modal-header">
            <Row isColumn className="text-center">
              <h3 className="text-primary">change password</h3>
            </Row>
          </div>
          <div className="modal-form">
            <Formsy.Form
              onValidSubmit={this.submit}
              onValid={this.enableButton}
              onInvalid={this.disableButton}
            >
              <Row isColumn>
                <Input
                  onChange={this.handlePassChange}
                  label="current password"
                  type="password"
                  name="password"
                  required
                />
              </Row>
              <Row isColumn>
                <Input
                  label="new password"
                  type="password"
                  name="new_password"
                  required
                />
              </Row>
              <Row isColumn>
                <Input
                  label="confirm password"
                  type="password"
                  name="confirm_password"
                  validations="equalsField:new_password"
                  validationErrors={{
                    equalsField: 'passwords do not match.'
                  }}
                  required
                />
              </Row>
              {!this.state.changedPass && userMsg ? (
                <Row isColumn>
                  <div
                    className={
                      'user-msg ' + this.props.passwordState.get('msgClass')
                    }
                  >
                    {userMsg}
                  </div>
                </Row>
              ) : null}
              <Row isColumn>
                <Button
                  className="change-password-button auth-button"
                  color={Colors.PRIMARY}
                  type="submit"
                  disabled={!this.state.canSubmit}
                  isExpanded
                >
                  update password
                </Button>
              </Row>
            </Formsy.Form>
          </div>
        </div>
      </Reveal>
    );
  }
});

const mapStateToProps = state => ({
  passwordState: state.auth.get('passwordState'),
  show: state.auth.get('showChangePasswordModal')
});

const mapDispatchToProps = dispatch => ({
  onSubmit: formData => {
    dispatch(changePassword(formData));
  },
  dispatch
});

export const ChangePasswordModal = connect(mapStateToProps, mapDispatchToProps)(
  ChangePassword
);



/** WEBPACK FOOTER **
 ** ./src/components/create-account/change-password.jsx
 **/